import * as LS from 'tsfront/preferences';
import { ThemeMode } from 'theme/ThemeInstance';

export const skipEmptyTiles = new LS.LsPreference<boolean>('boolean', 'scanview-skip-empty-tiles', true);
export const themeMode = new LS.LsPreference<ThemeMode>('string', 'theme-mode', 'dark');

